import Response from '../base/Response';

export default class InputErrorResponse extends Response {

}
